<template>
  <div class="form-wrap select-wrap">
    <label>{{ name }}</label>
    <select @input="e => $emit('input', e.target.value)" :value="value">
      <option v-for="option in options" :value="option.uuid" :key="option.uuid">
        {{ option.name }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    name: { type: String, required: true },
    options: { type: Array, required: true }, // [{ name: '', uuid: '' }, ...]
    value: { type: String, required: false },
  },
}
</script>
